import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillWindows,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import Tilt from "react-parallax-tilt";
import myImg from "../../Assets/jm-logo.jpg";

function Home2() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, []);
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={7} className="home-about-description">
          <txt className="divider" style={{ fontSize: "2.6em" }}>
            @Gadsdencode
            </txt>
            <p className="home-about-body">
              Identifying the disruptive potential of <b className="purple">Generative AI</b> in early 2023, I transitioned from observer to practitioner, rapidly mastering <b className="purple">local deployment and architecture</b>.
              <br />
              <br />
              My approach is defined by rigorous, <b className="purple">agile iteration</b>—dissecting complex software to engineer customized, <b className="purple">high-functioning solutions</b>.
              <br />
              <br />
              <txt className="divider">Technical Agility</txt>
              <br />
              <br />
              I possess a demonstrated ability to <b className="purple">rapidly assimilate</b> and deploy emerging technologies and enterprise systems.
              <br />
              <br />
              <i>
                <b className="purple">Core Competencies: </b>
                 VS Code, Replit, Vercel, QualtricsXM, GitHub, Miro, SmartSheet.
              </i>
              <br />
              <br />
              View the <b className="purple">About</b> page for a <b className="purple">comprehensive technical breakdown</b>.
              <br />
              <br />
              <txt className="divider">Mission</txt>
              <br />
              <br />
              Driven by the intersection of <b className="purple">human potential</b> and <b className="purple">artificial intelligence</b>, I build systems that empower people and <b className="purple">future-proof businesses</b>.
              <br />
              <br />
              Explore my <b className="purple">projects and resume</b> via the menu tabs. <b className="purple">Portfolion</b> is standing by to address specific inquiries.
            </p>
          </Col>
          <Col md={5} className="myAvatar">
          <br />
          <br />
          <br />
          <hr className="solid"></hr>
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" style={{borderRadius: "10%" }} />
            </Tilt>
            <br />
            <b className="purple">Portfolion AI<br /> Just click the Message icon<br />at bottom-right to chat with him! </b>
            <br />
            <b className="purple">He's programmed to answer questions<br /> about my skills, work experience,<br />and resume but he is capable<br />of answering much more. </b>
            <br />
            <br />
            <hr className="solid"></hr>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Socials</h1>
            <p>
              Multiple methods to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/gadsdencode"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/j-martens/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.overture-systems.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillWindows />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;